import createContainer from 'constate';
import config from '../../config';
import { requests } from '../../utils/DataUtil';

const yodleeURL = `${config.pronvest.api.url}Yodlee`;

const Yodlee = () => {
  return {
    getAdminData: (yodleeAccountId) =>
      requests.GET(`${yodleeURL}/${yodleeAccountId}/AdminData`),
    getBatchRelink: () => requests.GET(`${yodleeURL}/BatchRelink`),
    triggerBatchRelink: () => requests.POST(`${yodleeURL}/BatchRelink`),
  };
};

const [Provider, useYodlee] = createContainer(Yodlee);

export { useYodlee };

export default Provider;
